import { useState, useEffect } from "react";
import {
  loadAccountSettings,
  getDefaultAccountSettings,
  saveAccountSettings
} from "../utils/accountSettingsStorage";

export function useAccountSettings(user, { onActiveScopeGroupChange } = {}) {
  const [accountSettings, setAccountSettings] = useState(null);
  const [accountSaveState, setAccountSaveState] = useState("idle");
  const [showAccountPanel, setShowAccountPanel] = useState(false);
  const [isAccountButtonHovered, setIsAccountButtonHovered] = useState(false);

  useEffect(() => {
    let isMounted = true;
    async function init() {
      const storedSettings = await loadAccountSettings(user);
      if (!isMounted) return;
      setAccountSettings(storedSettings);
      if (storedSettings.workspace?.defaultEmissionsTab) {
        onActiveScopeGroupChange?.(storedSettings.workspace.defaultEmissionsTab);
      }
    }
    init().catch(() => {
      if (!isMounted) return;
      setAccountSettings(getDefaultAccountSettings(user));
      setAccountSaveState("loadError");
    });
    return () => { isMounted = false; };
  }, [user]);

  async function handleSaveAccountSettings(nextSettings, { onSuccess } = {}) {
    if (accountSaveState === "saving") return;
    try {
      setAccountSaveState("saving");
      const persistedSettings = await saveAccountSettings(user, nextSettings);
      setAccountSettings(persistedSettings);
      if (persistedSettings.workspace?.defaultEmissionsTab) {
        onActiveScopeGroupChange?.(persistedSettings.workspace.defaultEmissionsTab);
      }
      setAccountSaveState("saved");
      setShowAccountPanel(false);
      onSuccess?.();
    } catch (error) {
      console.error("Fehler beim Speichern der Kontoeinstellungen:", error);
      setAccountSaveState("error");
    }
  }

  return {
    accountSettings,
    setAccountSettings,
    accountSaveState,
    setAccountSaveState,
    showAccountPanel,
    setShowAccountPanel,
    isAccountButtonHovered,
    setIsAccountButtonHovered,
    handleSaveAccountSettings
  };
}
